<template>
      <div style="background:#f5f5f5" ref='tax'>
          <sbspSalaryFilter :filterList.sync="filterList">
             <el-form-item label="工资月份：" style="margin-right:40px;">
            <div>
                  <el-select  v-model="filterList[0].value"   placeholder="请选择" style="width:90px;">
                    <el-option  v-for="item in filterList[0].options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                  </el-select>
                  <el-date-picker v-if="filterList[0].value=='qt'" v-model="filterList[0].value2"  style="width:230px;margin-left:4px;"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
                  </el-date-picker>
              </div>
             </el-form-item>
          </sbspSalaryFilter>
          <div class="carBox" ref="carBox">
              <cardTwo v-for="(cardData,i) in cardDatas" :key="i" :cardData='cardData' :labels='labels' :keys='keys'>
                   <leftButton title="反馈结果" @click="_getTaxBatchById(cardData,i)" style="top:74px;"></leftButton>
                   <leftButton title="工资明细" @click="Jump({path: '/wage/wagesDetailList',query:{batchId:cardData.id,taxType:cardData.taxType,taxCompanyName:cardData.taxCompanyName,taxReportTime:cardData.taxReportTime,taxReportStatus:cardData.taxReportStatus}})" style="top:99px;"></leftButton>
                    <leftButton title="税金明细" @click="Jump({path: '/wage/taxDetailList',query:{batchId:cardData.id,taxType:cardData.taxType,taxCompanyName:cardData.taxCompanyName,taxReportTime:cardData.taxReportTime,taxReportStatus:cardData.taxReportStatus}})" style="top:124px;"></leftButton>
                    <!-- <leftButton title="申报明细" @click="details()" style="top:149px;"></leftButton>
                     <leftButton title="查询结果" @click="details()" style="top:174px;"></leftButton> -->
              </cardTwo>

          </div>
          <p class="more">
            <span @click="moreData()" v-if="cardDatas.length==6">查看更多></span>
          </p>
          <el-dialog
            ref="testDialog"
            width="420px"
            v-dialogDrag
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            title="反馈申报结果"
            :visible.sync="dialogFormVisible"
          >
            <div class="flex1">
                <div @click="changeStatus('已申报')"><span class="checkbox" :class="{'checked':currentData.taxReportStatus.trim()=='已申报'}"></span><span>已申报</span></div>
                <div @click="changeStatus('已缴款')"><span class="checkbox" :class="{'checked':currentData.taxReportStatus.trim()=='已缴款'}"></span><span>已缴款</span></div>
            </div>

            <div
              class="marginTop30"
              style="text-align: center"
            >
              <el-button
                type="primary"
                @click="updateStauts"
              >
                提交
              </el-button>
            </div>
          </el-dialog>
      </div>

</template>

<script>
  import sbspSalaryFilter from "@/wage-components/sbs-salary-filter/sbsp-salary-filter.vue"
  import cardTwo from "@/wage-components/sbs-salary-card/cardTwo.vue"
   import leftButton from "@/views/demo/salary/template/left-button.vue"
   import {getTaxList,updateTaxBatch,getTaxBatchById,queryLeavePerson} from "@/api/tax/tax"
  export default {
    name: "approval",
    components: {
      sbspSalaryFilter,
      cardTwo,
      leftButton
    },
    data() {
      return {
            msgPage: {
              limit: 6,
              page: 1,
              total: 0,
            },
            currentData:{},
            currentIndex:0,
            isBottom:false,
          labels:["发薪人数","税金总额","工资总额"],
          keys:['taxPerNum','payAccount','taxAccount'],
          dialogFormVisible:false,
        cardDatas:'',
        filterList: [
          { text: "工资月份", type: 'select-timer',value:'0',value2:'',
            options:[{
                value: '0',
                label: '一周内'
              }, {
                value: '1',
                label: '一月内'
              },{
                value: 'qt',
                label: '其他'
              }
              ]
          },

          { text: "批次名称", type: 'text',value:''},
          { text: "薪酬组", type: 'select',value:'0',
            options: [{
                value: '0',
                label: '黄金糕'
              }, {
                value: '1',
                label: '双皮奶'
              }, {
                value: '2',
                label: '蚵仔煎'
              }, {
                value: '3',
                label: '龙须面'
              }, {
                value: '4',
                label: '北京烤鸭'
              }]
          },
          { text: "审批状态", type: 'radio',value:'',
            options:[{
                value: '0',
                label: '待审批'
              }, {
                value: '1',
                label: '已审批'
              }]
          },
          { text: "社保月份", type: 'timer',value:'' },
           { text: "计税类型", type: 'text',value:'' },
        ]
      };
    },
    created(){
      this.filterLists = JSON.parse(JSON.stringify(this.filterList))
      getTaxList(this.msgPage).then(res=>{
        this.cardDatas = res.data.records;
      })

    },
    mounted(){
      window.addEventListener('scroll',()=>{
          var top = this.$refs.carBox.getBoundingClientRect().top;
					var height =  this.$refs.carBox.clientHeight;
					console.log(top+height-document.getElementsByClassName('main')[0].clientHeight)
					if(top+height-document.getElementsByClassName('main')[0].clientHeight<40){
						this.moreData();
					}
      } , true);
    },
    methods: {
      changeStatus(text){
          this.$set(this.currentData,'taxReportStatus',text);
          this.$forceUpdate();
      },


      _getTaxBatchById(cardData,i){
        this._queryLeavePerson();
        this.dialogFormVisible = true;
        this.currentIndex = i;
				Object.assign(this.currentData, cardData);
      },
      _queryLeavePerson(){
        debugger;
        queryLeavePerson(this.currentData).then(res => {
          let flag = res.data.flag;
          let leaveName = res.data.leavePerson;
          if(flag =='10020001'){
            this.isShow =true;
            let content = document.getElementById("tip");
            content.innerHTML=leaveName;
          }
        })
      },

      updateStauts() {
         updateTaxBatch(this.currentData).then(res => {
              this.dialogFormVisible = false
              this.$message.success('修改成功');
              console.log(this.currentData.id)
             getTaxBatchById(this.currentData.id).then(res=>{
                  this.cardDatas.splice(this.currentIndex,1,res.data.data);
             })
      //       this.$set(this.msgPage,'page',0);
      //         getTaxList(this.msgPage).then(res=>{
      //         this.cardDatas = res.data.records;
      // })
        })

      },
      Jump(path){
        this.$router.push(path);
      },
      moreData(){
        if(this.isBottom){
          return;
        }
        this.$set(this.msgPage,'page',this.msgPage.page+1);
        getTaxList(this.msgPage).then((res)=>{
          if(res.data.records.length<this.msgPage.limit){
              this.isBottom = true;
          }
          this.cardDatas = this.cardDatas.concat(res.data.records)
      })
      }
    }
  };
</script>

<style scoped >
  .carBox{
    margin-top:10px;
    display: flex;
    flex-wrap: wrap;
  }
  .more span{
font-size:13px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:rgba(64,158,255,1);
line-height:18px;
cursor: pointer;
  }
  .more{
    text-align: right;
  }
  .more span:hover{
    text-decoration: underline;
  }
  .flex1{
    display:flex;
    justify-content: space-around;
  }
  .flex1>div{
    cursor: pointer;
  }
  .flex1>div span{
		vertical-align: middle;
		font-size:12px;
		font-weight:400;
		color:rgba(0,0,0,1);
		margin-left: 10px;
	}
    .checkbox{
	   display: inline-block;
	   box-sizing: border-box;
	   width:13px;
		height:13px;
		border-radius:2px;
		border:1px solid rgba(220,220,220,1);
		position: relative;
		cursor: pointer;
   }
   .checkbox.checked::after{
	   content: '';
	   position: absolute;
	   width: 20px;
	   height: 15px;
	   background: url('../../../assets/img/dataImport/dui.svg') no-repeat;
	       top: -4px;
		   background-size: 100%;
   }
</style>
